import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  GetProductPagesRequest,
  GetProductPagesResponse,
  ProductPage,
  SaveProductPageRequest,
  SaveProductPageResponse,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class ProductPageService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/product-pages`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetProductPagesRequest): Promise<GetProductPagesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.status !== undefined && params.status !== '') {
        httpParams = httpParams.set('status', params.status)
      }

      const hasStartDate = !!params.startDate
      const hasEndDate = !!params.endDate

      if (hasStartDate && hasEndDate) {
        httpParams = httpParams.set('startDate', params.startDate!).set('endDate', params.endDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetProductPagesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<ProductPage> {
    const response = await firstValueFrom(this.http.get<ProductPage>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveProductPageRequest): Promise<SaveProductPageResponse> {
    const response = await firstValueFrom(this.http.post<SaveProductPageResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveProductPageRequest): Promise<SaveProductPageResponse> {
    const response = await firstValueFrom(this.http.put<SaveProductPageResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
